<!-- Hero Section -->
<div class="softwaredev-section-bg">
    <section class="softwaredev-section container py-5">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-5">
                    <h1 class="softwaredev-heading mb-3">
                        Kalpita Celebrates GPTW 2025
                    </h1>
                    <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
                    <div class="mb-5 contact-btn">
                        <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
                        <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
                    </div>
                </div>

                <div class="col-lg-7 text-center">
                    <img src="../../../../assets/resources/news-main/gptw-bannerimage.gif" alt="GPTW"
                        class="img-fluid hero-image">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
    <div class="container">
        <h2 class="section-title text-center">TL;DR</h2>
        <div class="takeaways-list">
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>Kalpita Technologies acquired its Great Place to Work Certification 2025 for the fourth successive
                    year.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>Great Place to Work® Certification™ is the “employer-of-choice” recognition that companies aspire to
                    achieve.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>This reflects Kalpita’s people-first culture and strong focus on employee well-being, and commitment
                    to innovation-driven growth.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>“Being certified for the fourth consecutive year reinforces our belief that when employees thrive,
                    the organization thrives.” – Kube, CEO</p>
            </div>
        </div>
    </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
    <div class="container">
        <h2 class="section-title text-center">Key Takeaways</h2>
        <div class="takeaways-list">
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>4th Consecutive Great Place to Work® Certification™ (since 2022) represents the recognition of our
                    trust-based, employee-centric culture.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>Kalpita is a People-First Workplace where Kalpitians are valued, supported, and empowered to thrive
                    personally and professionally.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>We have Freshers Programs where we onboard and train fresh tech talent in latest technologies,
                    certifications, and leadership pathways.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>We drive Innovation Across Industries by delivering AI-powered, human-centered digital solutions in
                    Insurtech, Fintech, Healthcare, and E-commerce.</p>
            </div>
            <div class="takeaway-item">
                <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
                <p>Our Vision Ahead is building a global reputation for purposeful innovation, collaboration, and
                    excellence.</p>
            </div>
        </div>
        <a href="https://businesssuccessstory.com/kalpita-technologies-secures-great-place-to-work-certification-2025-for-the-4th-consecutive-year/"
            target="_blank" class="btn case-study-btn">
            Read Full Article
        </a>
    </div>
</section>
<!-- Relevant Article -->
<app-relevant-newsarticle></app-relevant-newsarticle>